import { useAuthEventsInit } from './use-auth-events-init.hook';
import { useAcceptInvitePopupInit } from './use-accept-invite-popup-init.hook';
import { useLoginExpiration } from '../auth';

export const useAuthInit = () => {
    // initialize expiration and logout on close
    useLoginExpiration();

    // initialize auth events handler
    useAuthEventsInit();

    // initialize invite popup handler
    useAcceptInvitePopupInit();
};
